import { compassDirection, timeLabel } from './surf-forecast.mjs'

const finite = value => typeof value === 'number' && Number.isFinite(value)
export function travelBearing(sourceBearing) {
  return finite(sourceBearing) && sourceBearing >= 0 && sourceBearing <= 360 ? (sourceBearing + 180) % 360 : null
}
export function forecastClockHour(time) {
  return finite(time) && time > 0 ? Number(timeLabel(time).slice(0, 2)) : null
}
// Retain the chosen WITA clock hour when the day changes. Never substitute
// another sample for an explicitly requested hour that is missing.
export function selectedForecastHour(rows, clockHour, now) {
  const wanted = clockHour ?? forecastClockHour(now / 1000)
  if (!Number.isInteger(wanted) || wanted < 0 || wanted > 23) return null
  return rows.find(row => forecastClockHour(row.time) === wanted) || null
}
export function coastalMapReading(row) {
  const value = field => finite(row?.[field]) ? row[field] : null
  const direction = field => {
    const source = value(field), travel = travelBearing(source)
    return { source: travel === null ? null : source % 360, travel, from: travel === null ? null : compassDirection(source), toward: travel === null ? null : compassDirection(travel) }
  }
  return {
    // Deliberately no combined wave-height fallback: this map shows SWELL.
    swell: { height: value('swell_wave_height'), period: value('swell_wave_period'), ...direction('swell_wave_direction') },
    wind: { speed: value('wind_speed_10m'), gusts: value('wind_gusts_10m'), ...direction('wind_direction_10m') },
  }
}
